module.exports = __webpack_public_path__ + "img/pt-flag.608f9eab.png";